var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.625 34H6.375C2.85391 34 0 31.1461 0 27.625V6.375C0 2.85391 2.85391 0 6.375 0H27.625C31.1461 0 34 2.85391 34 6.375V27.625C34 31.1461 31.1461 34 27.625 34Z",
    fill: "#FFF9DD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4551 15.0098C25.3435 14.6656 25.0374 14.4223 24.6784 14.3893L19.7706 13.9432L17.8306 9.40317C17.6882 9.06932 17.3621 8.85376 16.9997 8.85376C16.6373 8.85376 16.3113 9.06932 16.1689 9.40317L14.2288 13.9432L9.32097 14.3893C8.96092 14.4223 8.65587 14.6656 8.54433 15.0098C8.43279 15.354 8.53577 15.7312 8.80788 15.9704L12.5181 19.2227L11.4237 24.04C11.343 24.3938 11.481 24.7604 11.7744 24.9728C11.9316 25.0877 12.1176 25.1451 12.3046 25.1451C12.4639 25.1451 12.6244 25.1025 12.7679 25.0164L16.9997 22.4867L21.2305 25.0164C21.5408 25.2014 21.9309 25.1855 22.224 24.9728C22.5174 24.7604 22.6554 24.3939 22.5747 24.04L21.4803 19.2227L25.1905 15.9693C25.4637 15.7312 25.5666 15.354 25.4551 15.0098H25.4551Z",
    fill: "#FFD200"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.37a69913.svg";
export { ForwardRef as ReactComponent };